// extracted by mini-css-extract-plugin
export default {"nextActionWhen":"nextActionWhen-DBeXB","modifyNextAction":"modifyNextAction-guQxi","modifyNextActionIcon":"modifyNextActionIcon-jttIB"};